export default __webpack_public_path__ + "static/media/up_icon.e43f54c5.svg";